import React, { useState, useRef, useEffect } from 'react';
import { productList } from '../../mock/moduleb';
import { useTranslation } from '../../context/LanguageContext';
import './ProductSelector.css';

const RESULT_META = {
  OK: { labelKey: 'pages.moduleb.common.resultOk', color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
  NG: { labelKey: 'pages.moduleb.common.resultNg', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

// 화면3·4 공용 제품 선택 드롭다운
function ProductSelector({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const ref = useRef(null);

  const current = productList.find((p) => p.shotId === value) || productList[0];

  // 외부 클릭 시 닫기
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="mb-product-selector" ref={ref}>
      <span className="mb-product-selector-label">{t('pages.moduleb.common.selectProduct')}</span>
      <button type="button" className="mb-product-selector-btn" onClick={() => setOpen((v) => !v)}>
        <span className="material-symbols-outlined mb-ps-icon">inventory_2</span>
        <span className="mb-ps-current">
          <span className="mb-ps-product">{current.productId}</span>
          <span className="mb-ps-shot">{current.shotId}</span>
        </span>
        <span
          className="mb-badge mb-ps-badge"
          style={{ color: RESULT_META[current.result].color, background: RESULT_META[current.result].bg }}
        >
          {t(RESULT_META[current.result].labelKey)}
        </span>
        <span className={`material-symbols-outlined mb-ps-arrow ${open ? 'open' : ''}`}>expand_more</span>
      </button>

      {open && (
        <div className="mb-product-selector-menu">
          {productList.map((p) => {
            const meta = RESULT_META[p.result];
            return (
              <button
                key={p.shotId}
                type="button"
                className={`mb-ps-item ${p.shotId === value ? 'active' : ''}`}
                onClick={() => {
                  onChange(p.shotId);
                  setOpen(false);
                }}
              >
                <span className="mb-ps-item-ids">
                  <span className="mb-ps-product">{p.productId}</span>
                  <span className="mb-ps-shot">{p.shotId}</span>
                </span>
                <span className="mb-ps-item-score">S {p.fusionScore.toFixed(2)}</span>
                <span className="mb-badge mb-ps-badge" style={{ color: meta.color, background: meta.bg }}>
                  {t(meta.labelKey)}
                </span>
                {p.shotId === value && <span className="material-symbols-outlined mb-ps-check">check</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ProductSelector;
